module.exports = __webpack_public_path__ + "static/media/ico_ticket2.873bdae4.svg";